// @ts-ignore
import { BaseCL } from "../vendor/murdej/ts-link-php/src/TsLinkPhp/BaseCL.ts";

export class MyBaseTL extends BaseCL {
	
}